import { render, staticRenderFns } from "./DataDragDrop.vue?vue&type=template&id=02856ed7&"
import script from "./DataDragDrop.vue?vue&type=script&lang=js&"
export * from "./DataDragDrop.vue?vue&type=script&lang=js&"
import style0 from "./DataDragDrop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports